import { GET_TEMPLATES } from "../../actions/types";

const initialState = {
  templates: [],
  template: null,
  loading: true,
  error: {},
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_TEMPLATES:
      return {
        ...state,
        templates: payload,
        loading: false,
      };
    default:
      return state;
  }
}
